import { maintenanceTemplateApi } from '../../../../api/maintenanceTemplateApi';
import { EditForm } from '../../TemplatesEditor/types';

/**
 * Saves a new maintenance template.
 *
 * @deprecated Use maintenanceTemplateApi.createTemplate() directly
 * This function is kept for backwards compatibility during migration.
 *
 * @param templateForm - The form data for the new template (must include primaryComponentType)
 * @returns The key of the newly created template
 */
export async function saveNewTemplate(templateForm: EditForm): Promise<string> {
    return maintenanceTemplateApi.createTemplate(templateForm);
}
